/*
 * Copyright (c) 2017-2018 Digital Bazaar, Inc. All rights reserved.
 */
'use strict';

var _defineProperty = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _module$exports;

var constants = require('./constants');

var _require = require('security-context'),
    securityContexts = _require.contexts;

module.exports = (_module$exports = {}, _defineProperty(_module$exports, constants.SECURITY_CONTEXT_V1_URL, securityContexts.get(constants.SECURITY_CONTEXT_V1_URL)), _defineProperty(_module$exports, constants.SECURITY_CONTEXT_V2_URL, securityContexts.get(constants.SECURITY_CONTEXT_V2_URL)), _module$exports);